import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=2d7d03f5&lang=pug"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"
import style0 from "./Resume.vue?vue&type=style&index=0&id=2d7d03f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports